export const CREATE_INVOICE_TXN = 'CREATE_INVOICE_TXN';
export const VOID_INVOICE_TXN = 'VOID_INVOICE_TXN';
export const GET_INVOICE_TXNS = 'GET_INVOICE_TXNS';
export const GET_INVOICE_TXNS_SUCCESS = 'GET_INVOICE_TXNS_SUCCESS';
